type EmailContactProps = {
    className?: string;
    size?: number;
    fill?: string;
};

const EmailContact = ({className, size = 20, fill = 'currentColor'}: EmailContactProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 21 21"
        fill="none"
        className={className}
        aria-hidden
    >
        <path
            d="M16.3333 7.375L19.6667 9.66667V18.4167C19.6667 18.7482 19.535 19.0661 19.3005 19.3006C19.0661 19.535 18.7482 19.6667 18.4167 19.6667H1.75C1.41848 19.6667 1.10054 19.535 0.866117 19.3006C0.631696 19.0661 0.5 18.7482 0.5 18.4167V9.66667L3.83333 7.375"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3 17.1666L7.16667 13.8333H13L17.1667 17.1666" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19.667 9.6665L14.667 12.9998" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.5 9.6665L5.5 12.9998" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M16.3335 11.8892V1.33333C16.3335 1.11232 16.2457 0.900358 16.0894 0.744078C15.9331 0.587797 15.7212 0.5 15.5002 0.5H4.66683C4.44582 0.5 4.23385 0.587797 4.07757 0.744078C3.92129 0.900358 3.8335 1.11232 3.8335 1.33333V11.8892"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.8335 6.75C8.8335 7.08152 8.96519 7.39946 9.19961 7.63388C9.43403 7.8683 9.75198 8 10.0835 8C10.415 8 10.733 7.8683 10.9674 7.63388C11.2018 7.39946 11.3335 7.08152 11.3335 6.75C11.3335 6.41848 11.2018 6.10054 10.9674 5.86612C10.733 5.6317 10.415 5.5 10.0835 5.5C9.75198 5.5 9.43403 5.6317 9.19961 5.86612C8.96519 6.10054 8.8335 6.41848 8.8335 6.75Z"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.3337 6.74987V7.37487C11.3337 7.65113 11.4434 7.91609 11.6388 8.11144C11.8341 8.30679 12.0991 8.41653 12.3754 8.41653C12.6516 8.41653 12.9166 8.30679 13.1119 8.11144C13.3073 7.91609 13.417 7.65113 13.417 7.37487V6.90487C13.4317 6.01596 13.1013 5.15595 12.4953 4.50548C11.8893 3.85501 11.0548 3.4647 10.167 3.41653C9.34117 3.38986 8.53484 3.67087 7.90444 4.20506C7.27405 4.73925 6.86453 5.48854 6.75532 6.30758C6.64612 7.12663 6.84501 7.95704 7.31342 8.63774C7.78183 9.31843 8.48637 9.8009 9.29037 9.99153C9.83298 10.1194 10.3987 10.1122 10.9379 9.9707"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default EmailContact;
